/**
 * Due-date colors, the same everywhere in the CRM (Adam and Michael, 16 Oct):
 * red is overdue, yellow is due within 10 days, green has more than 10 days,
 * gray has no date or is done.
 */
const DAY = 86400000;
const startOfToday = () => {
  const t = new Date();
  t.setHours(0, 0, 0, 0);
  return t.getTime();
};

export function daysLeft(due) {
  if (!due) return null;
  const d = new Date(due);
  d.setHours(0, 0, 0, 0);
  return Math.round((d.getTime() - startOfToday()) / DAY);
}

export function toneOf(due, done) {
  if (done || !due) return 'gray';
  const n = daysLeft(due);
  return n < 0 ? 'red' : n <= 10 ? 'yellow' : 'green';
}

export function dueText(due, done) {
  if (done) return 'Done';
  if (!due) return 'No date';
  const n = daysLeft(due);
  if (n < -1) return `${-n} days overdue`;
  if (n === -1) return 'Overdue since yesterday';
  if (n === 0) return 'Due today';
  if (n === 1) return 'Due tomorrow';
  return `Due in ${n} days`;
}

/** yyyy-mm-dd for date inputs, in local time. */
export function isoDay(d) {
  if (!d) return '';
  const t = new Date(d);
  return `${t.getFullYear()}-${String(t.getMonth() + 1).padStart(2, '0')}-${String(t.getDate()).padStart(2, '0')}`;
}
export const inDays = (n) => isoDay(new Date(Date.now() + n * DAY));
